import { Select, TextInput } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Col, Row, Container } from 'reactstrap';
import useTexts from '../hooks/useTexts';

import { useValidations } from '../../../../hooks/useValidations';
import { ClassroomFormFields } from '../../../../types/ClassroomTypes';
import { useClassroomOptionsLoader } from './Loaders/ClassroomOptionsLoader';
import { getSelectOptionsFromData } from '../utils';

const ClassroomForm = () => {
  const { t } = useTranslation();
  const { msgValidations } = useValidations();
  const { data } = useClassroomOptionsLoader();

  const texts = useTexts();

  const { control } = useFormContext<ClassroomFormFields>();

  const campusOptions = useMemo(() => {
    return getSelectOptionsFromData(data?.campuses);
  }, [data]);

  const classroomTypeOptions = useMemo(() => {
    return getSelectOptionsFromData(data?.types);
  }, [data]);

  return (
    <Container>
      <Row>
        <Col xs="12" md="6" className="mt-2 mt-md-0">
          <TextInput
            name="name"
            label={texts.form.name}
            control={control}
            rules={{
              required: msgValidations.required,
              minLength: {
                value: 3,
                message: t('common.validations.minLength', {
                  length: 3,
                }),
              },
            }}
          />
        </Col>
        <Col xs="12" md="6">
          <TextInput
            name="code"
            label={texts.form.code}
            control={control}
            rules={{
              required: msgValidations.required,
            }}
          />
        </Col>
      </Row>
      <Row className="mt-0 mt-md-3">
        <Col xs="12" md="6" className="mt-2 mt-md-0">
          <Select
            name={'type'}
            label={texts.form.type}
            options={classroomTypeOptions}
            control={control}
            rules={{ required: msgValidations.required }}
          />
        </Col>
        <Col xs="12" md="6" className="mt-2 mt-md-0">
          <Select
            name="campus"
            label={texts.form.campus}
            options={campusOptions}
            control={control}
            rules={{ required: msgValidations.required }}
          />
        </Col>
      </Row>
      <Row className="mt-0 mt-md-3">
        <Col xs="12" md="6" className="mt-2 mt-md-0">
          <TextInput
            name="capacity"
            label={texts.form.capacity}
            control={control}
            rules={{
              required: msgValidations.required,
              pattern: {
                value: /^[0-9]*$/,
                message: t('common.validations.invalidIntNumeric'),
              },
              min: {
                value: 1,
                message: t('common.validations.minNumber', {
                  num: 1,
                }),
              },
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default ClassroomForm;
